import axios from "axios";
import op from "../../../../modulos/datos";

class LicenciaService {
  constructor() {
    this.token = localStorage.getItem("jwtToken");
    this.conexion = op.conexion;
  }
  getHeaders() {
    return {
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
    };
  }
  async getAll(filtro, anio) {
    try {
      let condicion = '';
      if (filtro === "por_aprob") {
        condicion = "(estatussolicitud = 1 or estatussolicitud = 12) and ";
      } else if (filtro === "por_revi") {
        condicion = "estatussolicitud = 10 and ";
      } else if (filtro === "por_proce") {
        condicion = `estatussolicitud = 11 and `;
      } else if (filtro === "por_impr_lic") {
        condicion = `estatussolicitud = 13 and `;
      } else if (filtro === "aprob_impr") {
        condicion = `estatussolicitud = 2 and `;
      } else if (filtro === "aprob_entre") {
        condicion = `(estatussolicitud = 3 or (estatussolicitud = 1 and estatusnotificacion = 1 and usuarioentrega = 0 and usuarioaprueba != 0)) and `;
      } else if (filtro === "entregadas") {
        condicion = `(estatussolicitud = 4 or (estatussolicitud = 1 and usuarioentrega != 0)) and `;
      }
      condicion += `fechasolicitud between '${anio}-01-01' and '${anio}-12-31' `;

      const campos = `
      s.idsolicitudregistro,
      s.idcomercio,
      s.rif,
      s.nombre,
      s.direccion,
      s.actividadeconomica,
      s.tipoorganizacion,
      s.condicionestablecimiento,
      s.otracondicionestab,
      s.capitalsuscrito,
      s.capitalpagado,
      s.cedularepre,
      s.nombrerepre,
      s.telefonorepre,
      s.correorepre,
      s.fechasolicitud,
      s.montopagar,
      s.idpagosweb,
      s.estatussolicitud,
      s.estatusnotificacion,
      s.numfactura,
      s.idusuarioweb,
      s.aprobaciondia,
      s.usuarioaprueba,
      s.entregadia,
      s.usuarioentrega,
      s.motivorechazo,
      s.rechazodia,
      s.usuariorechaza,
      s.ut,
      s.sucursales,
      s.numsucursal,
      s.verificada,
      trim(COALESCE(p.nombres, '')) as nombre_persona,
      trim(COALESCE(p.apellidos, '')) as apellido_persona,
      trim(s.nombre) as nombre,
      trim(s.direccion) as direccion,
      CASE 
        WHEN estatussolicitud = 0 THEN 'PENDIENTE'
        when estatussolicitud = 1  then 'Por Aprobación'
        when estatussolicitud = 2 then 'IMPRESA POR FIRMA'
        when estatussolicitud = 3 or (estatussolicitud = 1 and estatusnotificacion = 1 and usuarioentrega = 0 and usuarioaprueba != 0) then 'POR RETIRAR'
        when estatussolicitud = 4 or (estatussolicitud = 1 and usuarioentrega != 0) then 'Entregados'
        when estatussolicitud = 10 then 'Por Revisión'
        when estatussolicitud = 11 then 'Por Procesar'
        when estatussolicitud = 12 then 'Revisado/Espera'
        when estatussolicitud = 13 then 'Por Imprimir Licencia'
      END AS status
      `;
      const tabla = `solicitudregistro s
      LEFT JOIN usuario u ON s.usuariorechaza = u.idusuario
      LEFT JOIN persona p ON p.cedula = CAST(
          regexp_replace(CAST(u.persona AS text), '[^0-9]', '', 'g') AS bigint
      )`;
      const orden = `s.idsolicitudregistro`;
      const response = await axios.get(
        `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condicion}&orden=${orden}`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new LicenciaService();
